import { useEffect, useRef, useState } from 'react'
import { IInputStatus } from '../../../../interface/progress.interface'
import isInViewport from '../../../../lib/utils/isInViewPort'
import whereIsElement, {
  ElementPosition,
} from '../../../../lib/utils/whereIsElement'

export const MAX_OPTIONS_HEIGHT = 250
export const GAP_SIZE = 10

const useSelect = ({
  name,
  value,
  styles,
  options,
  status,
  handler
}: {
  name: string,
  value: string,
  styles: any,
  options: any[],
  status: IInputStatus,
  handler: Function
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const selectRef = useRef<HTMLDivElement>(null)
  const optionsWrapperRef = useRef<HTMLDivElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const optionsArrRef = useRef<HTMLLIElement[]>(new Array(options.length))
  const [currentLabel, setCurrentLabel] = useState<string>('')
  const [hasError, setHasError] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const [clientHeight, setClientHeight] = useState<number>(
    //window.innerHeight ||
    document.documentElement.clientHeight || document.body.clientHeight
  )

  const handleClick = () => {
    setIsOpen((prev) => !prev)
  }
  useEffect(() => {
    console.log('useEffect', status)
  }, [status])

  const handleOptionClick = (value: string) => {
    wrapperRef.current?.classList.add(styles.full)
    handler(name, value, false)
  }
  const handleWindowClick = (event: MouseEvent) => {
    event.stopPropagation()
    if (
      event.target !== selectRef.current &&
      event.target !== wrapperRef.current &&
      optionsArrRef.current.findIndex((element) => element === event.target) ===
      -1
    ) {
      setIsOpen(false)
    }
  }

  const handleResize = () => {
    setClientHeight(
      //window.innerHeight ||
      document.documentElement.clientHeight || document.body.clientHeight
    )
  }

  useEffect(() => {
    if (value !== '' && value !== null) {
      wrapperRef.current?.classList.add(styles.full)
    }
    window.addEventListener(
      'click',
      handleWindowClick as EventListenerOrEventListenerObject
    )
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener(
        'click',
        handleWindowClick as EventListenerOrEventListenerObject
      )
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    console.log('useEffect', name, status)
    if (status === IInputStatus.error) {
      console.log('status error')
      setHasError(true)
      wrapperRef.current?.classList.add(styles.errorContent)
    } else {
      setHasError(false)
      wrapperRef.current?.classList.remove(styles.errorContent)
    }
  }, [status])

  useEffect(() => {
    // if (value !== '' && value !== null) {
    //   wrapperRef.current?.classList.add(styles.full)
    // }
    const currentOption = options.find(
      (option) => String(option.value) === value
    )
    console.log(currentOption, value, options)
    if (currentOption) {
      console.log('currentOption true')
      setCurrentLabel(currentOption.label)
      //handleClick()
    } else {
      setCurrentLabel('')
      // wrapperRef.current?.classList.remove(styles.open)
      wrapperRef.current?.classList.remove(styles.full)
      // selectRef.current?.classList.remove(styles.opacityValue)
    }
  }, [value])

  useEffect(() => {
    if (selectRef.current && wrapperRef.current) {
      if (isOpen) {
        selectRef.current?.classList.add(styles.opacityValue)
        wrapperRef.current?.classList.add(styles.open)
      } else {
        selectRef.current?.classList.remove(styles.opacityValue)
        wrapperRef.current?.classList.remove(styles.open)
      }
    }
  }, [isOpen])

  useEffect(() => {
    if (isOpen && optionsWrapperRef.current && selectRef.current) {
      const documentRect = document.documentElement.getBoundingClientRect()
      if (!isInViewport(selectRef.current)) {
        switch (whereIsElement(selectRef.current)) {
          case ElementPosition.BOTTOM:
            optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `${-(
              optionsWrapperRef.current.clientHeight +
              GAP_SIZE -
              (document.documentElement.clientHeight -
                selectRef.current.getBoundingClientRect().top)
            )}px`)
            break
          case ElementPosition.TOP:
            optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `calc(100% -${GAP_SIZE - selectRef.current.getBoundingClientRect().top
              }px)`)
            break
          default:
            optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `${-(
              optionsWrapperRef.current.clientHeight +
              GAP_SIZE -
              (document.documentElement.clientHeight -
                selectRef.current.getBoundingClientRect().top)
            )}px`)
        }
      } else if (!isInViewport(optionsWrapperRef.current)) {
        switch (whereIsElement(optionsWrapperRef.current)) {
          case ElementPosition.BOTTOM:
            optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `${-(
              optionsWrapperRef.current.clientHeight +
              GAP_SIZE -
              (document.documentElement.clientHeight -
                selectRef.current.getBoundingClientRect().top)
            )}px`)
            break
          default:
            optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `${-(
              optionsWrapperRef.current.clientHeight +
              GAP_SIZE -
              (document.documentElement.clientHeight -
                selectRef.current.getBoundingClientRect().top)
            )}px`)
        }
      } else {
        optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `100%`)
      }
    } else if (optionsWrapperRef.current) {
      optionsWrapperRef?.current?.style && (optionsWrapperRef.current.style.top = `100%`)
    }
  }, [isOpen])

  useEffect(() => {
    if (clientHeight && optionsRef.current) {
      if (MAX_OPTIONS_HEIGHT > clientHeight) {
        optionsRef?.current?.style && (optionsRef.current.style.maxHeight = `${clientHeight - GAP_SIZE * 2}px`)
      } else {
        optionsRef?.current?.style && (optionsRef.current.style.maxHeight = `${MAX_OPTIONS_HEIGHT}px`)
      }
    }
  }, [clientHeight])

  return {
    currentLabel,
    wrapperRef,
    selectRef,
    optionsWrapperRef,
    optionsRef,
    optionsArrRef,
    hasError,
    handleClick,
    handleOptionClick,
  }
}

export default useSelect
